import { render, staticRenderFns } from "./Block3Entrepreneur.vue?vue&type=template&id=d58d47cc"
import script from "./Block3Entrepreneur.vue?vue&type=script&lang=ts"
export * from "./Block3Entrepreneur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports